// extracted by mini-css-extract-plugin
export default {"paymentWrapper":"styles_paymentWrapper__upbiy","cardImg":"styles_cardImg__kZxdJ","remove":"styles_remove__fKv5g","status":"styles_status__Jke1F"};